import { render } from "./Activity.vue?vue&type=template&id=ba9da66c&scoped=true"
import script from "./Activity.vue?vue&type=script&lang=ts"
export * from "./Activity.vue?vue&type=script&lang=ts"

import "./Activity.vue?vue&type=style&index=0&id=ba9da66c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ba9da66c"

export default script